import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, getToken } from '../../api';
import { DEEP_QUESTIONS } from '../../data/questions';
import QuestionFlow from '../../components/QuestionFlow';

export default function DeepSearch() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!getToken()) { navigate('/login'); return null; }

  const handleComplete = async (answers) => {
    setSubmitting(true);
    try {
      if (answers.lifestyle.length) {
        await api.post('/lifestyle/submit', { answers: answers.lifestyle });
      }
      if (answers.dosha.length) {
        await api.post('/dosha/submit', { answers: answers.dosha });
      }
      if (answers.intimacy.length) {
        await api.post('/intimacy/submit', { answers: answers.intimacy });
      }
      localStorage.setItem('intake_path', 'deep');
      if (localStorage.getItem('swipe_test_done')) {
        navigate('/matches');
      } else {
        navigate('/onboarding/swipe-faces');
      }
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  if (submitting) {
    return (
      <div style={{ minHeight: '100vh', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="spinner" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', background: '#000', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
        <div className="error-msg" style={{ textAlign: 'center', marginBottom: 24 }}>{error}</div>
        <button className="btn btn-muted" style={{ maxWidth: 200 }} onClick={() => navigate('/onboarding/done')}>
          Continue anyway
        </button>
      </div>
    );
  }

  return <QuestionFlow questions={DEEP_QUESTIONS} onComplete={handleComplete} />;
}
